// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jBAq","type":"styles_type__3RdSS","choices":"styles_choices__3ltZc"};